// src/Component/hooks/useUpdatePengeluaran.jsx
import { useState } from 'react';
import api from '../Services/api';
import endpoints from '../Services/endpointAdmin';

/**
 * usePutPengeluaran adalah custom hook yang digunakan untuk memperbarui data pengeluaran di backend.
 * @returns { Object } - Mengembalikan fungsi putPengeluaran, serta status loading dan error.
 */
const usePutPengeluaran = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Fungsi untuk memperbarui data pengeluaran di backend.
   * @param { number } id - ID pengeluaran yang akan diperbarui.
   * @param { number } id_user
   * @param { number } id_detail_pengeluaran
   * @param { number } id_detail_himpun
   * @param { number } id_himpun
   * @param { string } sumber_dana
   * @param { string } user_input
   * @param { string } lembaga
   * @param { string } tanggal
   * @param { string } departemen
   * @returns { Promise<Object> } - Mengembalikan data respons dari backend atau error.
   */
  const putPengeluaran = async (
    id,
    id_user,
    id_detail_pengeluaran,
    id_detail_himpun,
    id_himpun,
    sumber_dana,
    user_input,
    lembaga,
    tanggal,
    departemen
  ) => {
    setLoading(true);
    setError(null);

    try {
      const data = {
        id_user,
        id_detail_pengeluaran,
        id_detail_himpun,
        id_himpun,
        sumber_dana,
        user_input,
        lembaga,
        tanggal,
        departemen,
      };

      if (!endpoints.pengeluaran || typeof endpoints.pengeluaran.update !== 'function') {
        throw new Error('endpoints.pengeluaran.update is not defined');
      }

      const response = await api.put(endpoints.pengeluaran.update(id), data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (err) {
      console.error('Error updating pengeluaran:', err);
      setError(
        err.response?.data?.error ||
        err.response?.data?.message ||
        err.message ||
        'Terjadi kesalahan saat memperbarui pengeluaran.'
      );
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { putPengeluaran, loading, error };
};

export default usePutPengeluaran;
